module.exports = __webpack_public_path__ + "static/img/case5icon.d6c7693.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/coorperation/case5icon.png
// module id = qBZm
// module chunks = 6